import DomesticStore from './domestic/store';
import OverseasStore from './overseas/store';

// eslint-disable-next-line no-undef
const store = IS_OVERSEAS ? OverseasStore : DomesticStore;
export default store;
